<template>
  <el-container class="entertainmentPlace">
    <!-- 单位信息 -->
    <el-card class="tree-card" :body-style="treeCard">
      <div class="tree-box">
        <el-card
          :class="{ hoverCard: ListIndex === index }"
          v-for="(item, index) in list"
          :key="index"
          shadow="always"
          @click="ListClick(item, index)"
        >
          <div class="mycard">
            <span>{{ item.name }}</span>
          </div>
        </el-card>
      </div>
    </el-card>
    <div class="divBody">
      <div class="bodyInput">
        <div style="display: flex; width: 300px">
          <span style="width: 100px">ip：</span>
          <el-input
            size="large"
            v-model="tableParams.ipModel"
            placeholder="请输入ip"
          ></el-input>
        </div>
        <div style="display: flex; width: 300px">
          <span style="width: 100px">端口：</span>
          <el-input
            size="large"
            v-model="tableParams.portModel"
            placeholder="请输入端口"
          ></el-input>
        </div>
        <div style="width: 100%">
          <el-button
            type=""
            size="large"
            style="margin-left: 10px"
            @click="submit"
            >确定</el-button
          >
        </div>
        <div>
          <span>返回结果：{{ result }}</span>
        </div>
      </div>
    </div>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
// import { ElMessageBox, ElMessage } from "element-plus";
import {
  getTime,
  setLocalhostTime,
} from "@/api/systemTimeCalibration/systemTimeCalibration.js";
import _ from "lodash";
export default defineComponent({
  name: "entertainmentPlace",
  components: {},
  props: {},
  setup(props) {
    const state = reactive({
      ListIndex: 0,
      result: "",
      tableParams: {
        ipModel: "50.136.11.100",
        portModel: "123",
      },
      componentIs: "entertainmentPlaceJB",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      treeCards: {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      },
      list: [
        {
          name: "获取设备时间",
          is: "entertainmentPlaceJB",
        },
        {
          name: "更新服务器时间",
          is: "entertainmentPlaceKTV",
        },
      ],
    });
    const refData = toRefs(state);
    const ListClick = (item, index) => {
      state.ListIndex = index;
      state.componentIs = item.is;
      state.result = "";
    };
    const submit = async (item, index) => {
      let res;
      if (state.componentIs == "entertainmentPlaceJB") {
        const params = {
          ipaddr: state.tableParams.ipModel,
        };
        res = await getTime(params, {
          loading: true,
          loadingDom: ".divBody",
        });
        state.result = res.data;
      } else {
        const params = {
          ipaddr: state.tableParams.ipModel,
        };
        res = await setLocalhostTime(params, {
          loading: true,
          loadingDom: ".divBody",
        });
        state.result = res.flag;
      }

      console.log(res);
    };
    return {
      ...refData,
      ListClick,
      submit,
    };
  },
});
</script>
<style lang="scss" scoped>
.entertainmentPlace {
  .divBody {
    padding: 10px;
    width: calc(100% - 300px);
    display: flex;
    align-items: center;
    justify-content: center;
    .bodyInput {
      width: 400px;
      height: 200px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 24px;
    }
  }
  .tree-card {
    height: 100%;
    width: 300px;

    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .hoverCard {
        // background: red;
        border: 1px solid #3a74fb;
        border-left: 5px solid #3a74fb;
        color: #3a74fb;
      }
      .el-card {
        margin: 10px 0 !important;
        :deep(.el-card__body) {
          display: flex !important;
          width: 100% !important;
          justify-content: space-around !important;
          cursor: pointer;
        }
        .mycard {
          display: flex !important;
          justify-content: space-between;
        }
      }
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
}
</style>
